import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private activeRequests = 0;
  private readonly _loading$ = new BehaviorSubject<boolean>(false);
  readonly loading$ = this._loading$.asObservable();

  show(): void {
    this.activeRequests++;
    if (!this._loading$.value) {
      this._loading$.next(true);
    }
  }

  dismiss(): void {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    if (this.activeRequests === 0) {
      this._loading$.next(false);
    }
  }

  /** Force-hide regardless of the counter (e.g. on route change or fatal error). */
  reset(): void {
    this.activeRequests = 0;
    this._loading$.next(false);
  }
}